export const safeDate = (
  s, // string or falsy
  fallback = new Date(null), // unix time startpoint
) => s ? new Date(s) : fallback
